import { render, staticRenderFns } from "./iconCorderos-white.vue?vue&type=template&id=29533f19&scoped=true&"
import script from "./iconCorderos-white.vue?vue&type=script&lang=js&"
export * from "./iconCorderos-white.vue?vue&type=script&lang=js&"
import style0 from "./iconCorderos-white.vue?vue&type=style&index=0&id=29533f19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29533f19",
  null
  
)

export default component.exports